import { render } from "./SystemIcon.vue?vue&type=template&id=787fce2e&scoped=true"
import script from "./SystemIcon.vue?vue&type=script&lang=js"
export * from "./SystemIcon.vue?vue&type=script&lang=js"

import "./SystemIcon.vue?vue&type=style&index=0&id=787fce2e&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787fce2e"]])

export default __exports__